export const formatFileName = (fileName: string) => {
  const name = fileName.replace(/\s/g, '-').toLowerCase().split('.')[0];
  const extension = fileName.split('.')[1];

  const date = new Date();
  const formattedDate = date.toISOString().split('T')[0];
  const dateNumber = date.getTime();

  return `${name}-${formattedDate}-${dateNumber}.${extension}`;
};
